import { render, staticRenderFns } from "./modalViewAbertura.vue?vue&type=template&id=1d80c7f6"
import script from "./modalViewAbertura.vue?vue&type=script&lang=js"
export * from "./modalViewAbertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports